export default "__VITE_ASSET__a0ySkugp__"